import * as React from 'react';
import type { ReactNode } from 'react';
import { styled } from '@mui/material';
import { FlowDetailHeaderProps } from '../../types/flow.types';

export const EntityDetailCardStyled = styled('header')<FlowDetailHeaderProps>(({
  theme,
  status,
}) => {
  const pulsingBlue =
    status === 'running'
      ? {
          borderTop: '4px solid #3174AB',
          animation: 'pulseBorder 1.5s infinite',
          '@keyframes pulseBorder': {
            '0%': { borderTopColor: '#3174AB' },
            '50%': { borderTopColor: '#90caf9' },
            '100%': { borderTopColor: '#3174AB' },
          },
        }
      : {};
  return {
    margin: '0 4em',
    padding: '1em 2em',
    borderRadius: '4px',
    background: theme.palette?.common?.white,
    color: theme.palette?.common?.black,
    boxShadow: '5px 0 5px rgba(173, 216, 230, 0.25)',
    // @ts-expect-error status is not in the type but is used for conditional border
    ...(['healthy', 'unhealthy'].includes(status) && {
      borderLeft: `3px solid ${status === 'healthy' ? theme.palette.success.light : theme.palette.error.light}`,
    }),
    ...pulsingBlue,
  };
});

export const EntityDetailCard = ({
  children,
  isLoading,
  isSuccess,
  status,
}: {
  children?: ReactNode;
  isLoading?: boolean;
  isSuccess?: boolean;
  status?: string;
}) => (
  <EntityDetailCardStyled status={status}>
    <section
      data-cy="flow-entity-detail-card"
      style={{ display: 'flex', margin: '0 auto' }}
    >
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child as React.ReactElement<any>, {
              isLoading,
              isSuccess,
            })
          : child,
      )}
    </section>
  </EntityDetailCardStyled>
);

export const EntityDetailCardSection = styled('section')(({ theme }) => ({
  padding: '0 1em',
  width: '100%',
  minHeight: '70px',
  alignItems: 'stretch',
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  '&:first-child': {
    paddingLeft: 0,
  },
  '&:last-child': {
    borderRight: 'none',
  },
  '* ': {
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
  },
}));
